import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom"; // Importe useLocation
import { Tab, Tabs } from "@mui/material";
import FilterBar from "../../../../components/topBarFilter";
import { temErp } from "../../../../services/erpSistema";

export default function Geral() {
  const navigate = useNavigate();
  const location = useLocation(); // Hook para observar a URL atual
  const [value, setValue] = useState(0);

  const navPages = [
    `/interno/administracao/geral/relatorio`,
    `/interno/administracao/geral/clientes`,
    `/interno/administracao/geral/suporte`,
    `/interno/administracao/geral/permissoes`,
    `/interno/administracao/geral/pingIcons`,
    `/interno/administracao/geral/flow`,
    `/interno/administracao/geral/configInterno`,
  ];

  useEffect(() => {
    const currentPath = location.pathname;

    // Encontra o índice da página atual na lista navPages
    const currentIndex = navPages.findIndex((page) =>
      currentPath.includes(page),
    );

    // Se encontrou a página (index diferente de -1), define o valor exato
    if (currentIndex !== -1) {
      setValue(currentIndex);
    } else if (
      currentPath === "/interno/administracao/geral" ||
      currentPath === "/interno/administracao/geral/"
    ) {
      navigate("/interno/administracao/geral/relatorio", { replace: true });
    }
  }, [location.pathname]); // Reage sempre que a rota mudar

  const handleChange = (event, newValue) => {
    // Agora o newValue vindo das Tabs será 0, 1 ou 2
    navigate(navPages[newValue]);
  };

  return (
    <>
      <FilterBar widthParamsMobile={1} />
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
      >
        <Tab label="Relatório" />

        <Tab label="Clientes" />
        <Tab
          label="Suporte"
          // Suporte: telas da HubSoft e do IXC (ERPs do sistema, não a variável).
          disabled={!temErp("HUBSOFT") && !temErp("IXC")}
        />
        <Tab label="Permissões" />
        <Tab label="Lista de Pings" />
        <Tab label="Configurações flow" />
        <Tab label="Configuração interna" />
      </Tabs>
      <Outlet context={[]} />
    </>
  );
}
